<template>
  <memlist-modal size="lg" ref="sendout_template-edit-modal">
    
    <form class="mt-8" v-if="local_item">

      <m-row class="mt-4">

        <m-col md="6" sm="12">
          
          <memlist-select-input2
            v-model="local_item.type"
            :items="sendout_template_type_options"
            :title="$t('SENDOUT_TEMPLATE.TYPE')"
            layout="vertical"
            size="sm"
            validation_type="TEXT"
          />

        </m-col>

        <m-col md="6" sm="12">
            
          <memlist-select-input2
            v-model="local_item.template_id"
            :items="template_options"
            :title="$t('SENDOUT_TEMPLATE.TEMPLATE_ID')"
            layout="vertical"
            size="sm"
            validation_type="TEXT"
          />
        </m-col>

      </m-row>

      <m-row class="mt-4">

        <m-col md="6" sm="12">
          <memlist-text-input
            v-model="local_item.created_at"
            :title="$t('SENDOUT_TEMPLATE.CREATED_AT')"
            layout="vertical"
            :disabled="true"
            type="text"
            size="sm"
            validation_type="TEXT"
          />
        </m-col>

        <m-col md="6" sm="12">
          <memlist-checkbox
            style="margin-top: 26px;"
            v-model="local_item.is_active"
            :title="$t('SENDOUT_TEMPLATE.IS_ACTIVE')"
          />
        </m-col>

      </m-row>

      <p style="margin-top: 42px;"></p>

      <m-row class="mt-4">
        <m-col lg="12">
          <RightModalSaveAndCloseButtons
            :text="$t('COMMON.OK')"
            :spin="true"
            @click="on_submit"
            @close="$refs['sendout_template-edit-modal'].hide()"
            ref="saveButton" />
        </m-col>
      </m-row>
    </form>

  </memlist-modal>
</template>

<script>

// axios is REST API
import axios from 'axios';

// popup messages in the corner
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

// vuex state, storage
import { mapGetters } from 'vuex';
import RightModalSaveAndCloseButtons from '@/view/components/buttons/RightModalSaveAndCloseButtons.vue';


export default {
  name: 'SendoutTemplateEditorModal',
  mixins: [ toasts ],
  props: ['item'],
  emits: ['created', 'updated'],
  
  components: {
    RightModalSaveAndCloseButtons
  },
  
  computed: {

    template_options() {
      return this.templates.map(item => ({ value: item.template_id, text: item.name }));
    },

    sendout_template_type_options() {

      let base = [
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.DONATION_NEW_DONATION_RECEIVED'), value: 'DONATION_NEW_DONATION_RECEIVED' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.DONATION_THANK_YOU_SINGLE'), value: 'DONATION_THANK_YOU_SINGLE' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.DONATION_THANK_YOU_RECURRING'), value: 'DONATION_THANK_YOU_RECURRING' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SIMPLE_FORM_ANSWERED'), value: 'SIMPLE_FORM_ANSWERED' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.TICKET_EVENT'), value: 'TICKET_EVENT' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.TICKET_EVENT_ADMIN_NOTIFICATION'), value: 'TICKET_EVENT_ADMIN_NOTIFICATION' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.TODO_UPDATED'), value: 'TODO_UPDATED' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.EMAIL_VERIFY'), value: 'EMAIL_VERIFY' },

        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.ADMIN_RESET_PASSWORD'), value: 'ADMIN_RESET_PASSWORD' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.MEMBER_RESET_PASSWORD'), value: 'MEMBER_RESET_PASSWORD' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.MEMBER_WELCOME'), value: 'MEMBER_WELCOME' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.ADMIN_WELCOME'), value: 'ADMIN_WELCOME' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.TEMPLATE_NEWSLETTER'), value: 'TEMPLATE_NEWSLETTER' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.RENEW_CONFIRM_EMAIL'), value: 'RENEW_CONFIRM_EMAIL' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.RENEW_CONFIRM_SMS'), value: 'RENEW_CONFIRM_SMS' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.RENEW_EMAIL'), value: 'RENEW_EMAIL' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.RENEW_SMS'), value: 'RENEW_SMS' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.RENEW_REMINDER_EMAIL'), value: 'RENEW_REMINDER_EMAIL' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.RENEW_REMINDER_SMS'), value: 'RENEW_REMINDER_SMS' },

        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.INVOICE_BY_EMAIL'), value: 'INVOICE_BY_EMAIL' },

        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.GRANT_APPLICATION_CREATED'), value: 'GRANT_APPLICATION_CREATED' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.GRANT_ACCEPTED'), value: 'GRANT_ACCEPTED' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.GRANT_REJECTED'), value: 'GRANT_REJECTED' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.GRANT_MUST_HANDIN'), value: 'GRANT_MUST_HANDIN' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.GRANT_HAS_HANDIN'), value: 'GRANT_HAS_HANDIN' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.GRANT_FINALIZED'), value: 'GRANT_FINALIZED' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.STICKPROV_SMS'), value: 'STICKPROV_SMS' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.STICKPROV_EMAIL'), value: 'STICKPROV_EMAIL' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.MEMBER_APPROVED'), value: 'MEMBER_APPROVED' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.MEMBER_REJECTED'), value: 'MEMBER_REJECTED' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.MEMBER_PENDING'), value: 'MEMBER_PENDING' },
        { text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.MFA_EMAIL'), value: 'MFA_EMAIL' },

      ];

      if (this.isTHS) {
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SAMFUND_MEMBERS_ERROR_REPORT'), value: 'SAMFUND_MEMBERS_ERROR_REPORT' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.GENERAL_ERROR_REPORT'), value: 'GENERAL_ERROR_REPORT' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.DONATION_NEW_CUSTOMER'), value: 'DONATION_NEW_CUSTOMER' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.DONATION_WELCOME_ADMIN'), value: 'DONATION_WELCOME_ADMIN' });
      }

      if (this.global_settings.type === 'kvitto') {
        
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.EMAIL_NOT_MATCHED'), value: 'EMAIL_NOT_MATCHED' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.KVITTO_RECEIVED_AND_FORWARDED'), value: 'KVITTO_RECEIVED_AND_FORWARDED' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.KVITTO_ERROR'), value: 'KVITTO_ERROR' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.KVITTO_NO_RULE_MATCHED'), value: 'KVITTO_NO_RULE_MATCHED' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.KVITTO_RECEIVED'), value: 'KVITTO_RECEIVED' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.KVITTO_MATCHED'), value: 'KVITTO_MATCHED' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.KVITTO_NOT_MATCHED'), value: 'KVITTO_NOT_MATCHED' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.ACCOUNT_TRANSACTION_NEED_MATCH'), value: 'ACCOUNT_TRANSACTION_NEED_MATCH' });
      }

      if (this.global_settings.type === 'support') {

        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SALES_INFO_MAIL'), value: 'SALES_INFO_MAIL' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SALES_INVITE_MEETING'), value: 'SALES_INVITE_MEETING' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SALES_FOLLOW_UP'), value: 'SALES_FOLLOW_UP' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SALES_SIGN_CONTRACT'), value: 'SALES_SIGN_CONTRACT' });
        base.push({ text: this.$t('TEMPLATE.SENDOUT_TEMPLATES.SALES_WELCOME_AFTER_SIGN'), value: 'SALES_WELCOME_AFTER_SIGN' });
      }

      base.sort((a, b) => {
        if (a.text < b.text) {
          return -1;
        }

        return 1;
      });

      return base;
    },

    // which stored data we want to use
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'settings', 'periods', 'customer', 'global_settings', 'isTHS'])
  },
  mounted() {
    
    this.fetch_template_options();
  },
  data() {
    return {
      local_item: {},

      templates: []
    };
  },
  watch: {
    item: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        if (this.item) {
          this.local_item = { ...this.item };
        }
      },
      immediate: true
    },

    currentCompanyId() {
      // triggers when user has changed company on top
      // we should reload content based on selected company
    },
    currentPeriodId() {
      // triggers when user has changed period on top
      // we should reload content based on period
    }

  },
  methods: {

    async fetch_template_options() {
      const res = await axios.get(`/template?company_id=${this.currentCompanyId}&show_system=true`);

      if (res.status === 200) {
        this.templates = res.data;
      }
    },

    on_submit() {
      if (this.local_item.id) {
        this.put_item();
      }
      else {
        this.post_item();
      }

      this.$refs['saveButton'].stop();
    },

    async put_item() {
      const res = await axios.put(`/template/sendout/${this.local_item.id}`, this.local_item);

      if (res.status === 204) {
        this.$emit('updated', this.local_item);
      }
    },

    async post_item() {
      this.local_item.customer_id = this.customer.id;
      const res = await axios.post(`/template/sendout`, this.local_item);

      if (res.status === 201) {
        this.local_item = res.data;
        this.$emit('created', this.local_item);
      }
    },

    // add any methods we need
    show() {
      this.$refs['sendout_template-edit-modal'].show();
    },

    hide() {
      this.$refs['sendout_template-edit-modal'].hide();
    }
  }
};
</script>
